import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
import TopExportCSV from "../../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class PojazdyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            wszystkieKolumnyEksport: [
                {value: "idPo", label: 'ID Pojazdu'},
                {value: "marka", label: 'Marka'},
                {value: "model", label: 'Model'},
                {value: "nrRej", label: 'Numer rejestracji'},
                {value: "ileMiejsc", label: 'Ilość miejsc'},
                {value: "normaSpalin", label: 'Norma spalin'},
                {value: "status", label: 'Status'},
                {value: "uwagi", label: 'Uwagi'},
                {value: "wifi", label: 'WiFi'},
                {value: "dataOc", label: 'Data OC'},
                {value: "dataAc", label: 'Data AC'},
                {value: "dataBt", label: 'Data BT'},
                {value: "dataPt", label: 'Data PT'},
                {value: "certRej", label: 'Cert rej'},
                {value: "nrNadw", label: 'Numer nadwozia'},
            ],

            kolumnyDoExportuDefault: [
                {value: "idPo", label: 'ID Pojazdu'},
                {value: "marka", label: 'Marka'},
                {value: "model", label: 'Model'},
                {value: "nrRej", label: 'Numer rejestracji'},
                {value: "ileMiejsc", label: 'Ilość miejsc'},
                {value: "normaSpalin", label: 'Norma spalin'},
                {value: "status", label: 'Status'},
                {value: "uwagi", label: 'Uwagi'},
                {value: "wifi", label: 'WiFi'},
                {value: "dataOc", label: 'Data OC'},
                {value: "dataAc", label: 'Data AC'},
                {value: "dataBt", label: 'Data BT'},
                {value: "dataPt", label: 'Data PT'},
                {value: "certRej", label: 'Cert rej'},
                {value: "nrNadw", label: 'Numer nadwozia'},
            ],

        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointEdit onClick={()=>{this.props.handleEdytuj(row)}} titleContent={'Edytuj pojazd'}/>
                <TopButtonPointRemove onClick={()=>{this.props.handleUsun(row)}} titleContent={'Usuń pojazd'}/>
            </div>
        )
    }

    formatStatusy(cell,row){
        if(cell == 1) return (<span style={{fontSize:'12px', color:'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>)
        else return (<span style={{fontSize:'12px', color:'firebrick'}}><i className={'fa fa-times'}></i> niedostępny</span>)
    }

    render() {

        let statusy = {
            1: 'dostępny',
            0: 'niedostępny'
        }

        const options = {
            sizePerPage: 15,  // Showing 15 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
            <div className="bigger_table_for_1399">
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idPo' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='marka'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Marka</TableHeaderColumn>
                    <TableHeaderColumn dataField='model'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Model</TableHeaderColumn>
                    <TableHeaderColumn dataField='nrRej'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Rejestracja</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileMiejsc'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Miejsca</TableHeaderColumn>
                    <TableHeaderColumn dataField='status'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={ { type: 'SelectFilter', options: statusy, selectText: 'Wybierz' } } dataFormat={ this.formatStatusy } formatExtraData={ statusy }
                    >Status</TableHeaderColumn>

                    <TableHeaderColumn dataField='dataAc'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'DateFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >AC</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataOc'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'DateFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >OC</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataBt'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'DateFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data badania techicznego</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataPt'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'DateFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data przeglądu tachografem</TableHeaderColumn>
                    <TableHeaderColumn dataField='wifi'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Nr WIFI</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPo'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/pojazdy/components/PojazdyTable.js